// Update contents object below
const contents = {
  header: 'Client Name', //update with your client name
  logoTooltip: {
    href: 'https://www.courageousstudios.com/', //where the logo click drives to
    copy: 'www.courageousstudios.com/' // tooltip content
  },
  hero: {
    background: 'video', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: '',
    copy: ''
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      {
        class: 'photo1',
        caption: 'With an assist from AI, retailers are cutting wait times for their customers.'
      },
      {
        class: 'photo2',
        caption:
          'With Pathr.ai’s dashboard, retailers can access analytics on their desktop and tablet and even get real-time alerts sent to their mobile phones. '
      },
      {
        class: 'photo3',
        caption:
          'Operations managers can deploy responsive AI to dispatch employees to help customers and improve the retail experience, particularly at big box stores and shopping centers.'
      },
      { class: 'photo4', caption: '' }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href: 'https://www.lenovo.com/us/en/servers-storage/alliance/ai-innovators/', //where the cta button click drives to
    copy: 'https://www.lenovo.com/' //tooltip content
  }
};

export default contents;
